export const ADMIN_ACTION_LABELS = {
  // Aprovação e status do usuário
  approved_psychologist: "Psicólogo aprovado",
  disapproved_psychologist: "Psicólogo desaprovado",
  activated_user: "Usuário ativado",
  deactivated_user: "Usuário desativado",
  reactivated_user: "Usuário reativado",
  deleted_user: "Usuário excluído",
  blocked_agenda: "Agenda bloqueada",
  unblocked_agenda: "Agenda desbloqueada",

  // Credenciais e perfil
  generated_password_reset_link: "Link de reset de senha gerado",
  changed_user_email: "Email alterado",
  changed_call_provider: "Call provider alterado",
  changed_crp_photos: "Fotos de documento alteradas",

  // Assinaturas
  gave_subscription_free: "Assinatura gratuita concedida",
  granted_free_days: "Dias grátis concedidos",
  granted_free_month: "Mês grátis concedido",
  granted_free_premium: "Premium grátis concedido",
  removed_free_premium: "Premium grátis removido",
  canceled_subscription: "Assinatura cancelada",
  reactivated_subscription: "Assinatura reativada",

  // Pagamentos e estornos
  refunded_appointment: "Sessão reembolsada",
  refunded_appointment_boleto: "Sessão (boleto) estornada",
  refunded_subscription_invoice: "Fatura de assinatura reembolsada",
  force_charged_appointment: "Cobrança forçada em sessão",
  granted_stripe_credit: "Crédito Stripe concedido",

  // Stripe Connect
  reset_stripe_connect: "Conta Stripe Connect resetada",
  created_bank_account: "Conta bancária criada",

  // Sessões / recorrências
  created_free_session: "Sessão gratuita criada",
  canceled_appointment_recurrency: "Recorrência cancelada",
  changed_appointment_date: "Data da sessão alterada",

  // Parcerias
  created_partnership: "Parceria criada",
  updated_partnership_credits: "Limites da parceria atualizados",

  // Configurações
  updated_terms_of_use: "Termos de uso atualizados",
};

export const ADMIN_TARGET_LABELS = {
  psychologist: "Psicólogo",
  patient: "Paciente",
  user: "Usuário",
  appointment: "Sessão",
  appointment_recurrency: "Recorrência",
  subscription: "Assinatura",
  subscription_invoice: "Fatura de assinatura",
  partnership: "Parceria",
  settings: "Configurações",
};

export const ADMIN_ACTION_GROUPS = [
  {
    label: "Aprovação e status do usuário",
    actions: [
      "approved_psychologist",
      "disapproved_psychologist",
      "activated_user",
      "deactivated_user",
      "reactivated_user",
      "deleted_user",
      "blocked_agenda",
      "unblocked_agenda",
    ],
  },
  {
    label: "Credenciais e perfil",
    actions: [
      "generated_password_reset_link",
      "changed_user_email",
      "changed_call_provider",
      "changed_crp_photos",
    ],
  },
  {
    label: "Assinaturas",
    actions: [
      "gave_subscription_free",
      "granted_free_days",
      "granted_free_month",
      "granted_free_premium",
      "removed_free_premium",
      "canceled_subscription",
      "reactivated_subscription",
    ],
  },
  {
    label: "Pagamentos e estornos",
    actions: [
      "refunded_appointment",
      "refunded_appointment_boleto",
      "refunded_subscription_invoice",
      "force_charged_appointment",
      "granted_stripe_credit",
    ],
  },
  {
    label: "Stripe Connect",
    actions: ["reset_stripe_connect", "created_bank_account"],
  },
  {
    label: "Sessões / recorrências",
    actions: [
      "created_free_session",
      "canceled_appointment_recurrency",
      "changed_appointment_date",
    ],
  },
  {
    label: "Parcerias",
    actions: ["created_partnership", "updated_partnership_credits"],
  },
  {
    label: "Configurações",
    actions: ["updated_terms_of_use"],
  },
];

export const labelOfAction = (action) =>
  ADMIN_ACTION_LABELS[action] ?? action;

export const labelOfTarget = (target) =>
  ADMIN_TARGET_LABELS[target] ?? target;
